import i18n from "../i18n";

/**
 * Table de libellés « paresseuse » : associe un code (statut, type...) à une
 * clé de traduction et traduit au moment de la lecture (rendu), et non au
 * chargement du module. Ainsi le libellé suit la langue courante.
 *
 *   const statusLabels = lazyLabels({ draft: "common.examStatus.draft" });
 *   statusLabels[status]  // -> texte traduit
 */
export const lazyLabels = (keys) =>
  new Proxy(keys, {
    get: (target, prop) =>
      typeof prop === "string" && typeof target[prop] === "string"
        ? i18n.t(target[prop])
        : undefined,
  });

/** Locale des dates/nombres selon la langue de l'interface (chiffres latins en arabe). */
export const getLocale = () =>
  (i18n.language || "fr").startsWith("ar") ? "ar-u-nu-latn" : "fr-FR";

/** Durée « 12 min 05 s » à partir d'un nombre de secondes. */
export const formatDuration = (totalSeconds) => {
  if (totalSeconds === null || totalSeconds === undefined) return "-";
  const m = Math.floor(totalSeconds / 60);
  const s = String(totalSeconds % 60).padStart(2, "0");
  return i18n.t("common.units.duration", { m, s });
};
